import React from "react";

import { AddButton } from "../AddButton/AddButton";

import "./EdgeAddButton.scss";

const EdgeAddButton = (props) => {
  const { style } = props;

  return (
    <div className="EdgeAddButton" style={style}>
      <AddButton {...props} />
    </div>
  );
};

export default EdgeAddButton;
